<template>
  <el-dialog
    title="新增会员价格"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >

      <el-form-item
              prop="title"
              label="标题"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.title"></el-input>
      </el-form-item>

      <el-form-item
              prop="title_details"
              label="会员特权"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.title_details"></el-input>
      </el-form-item>

      <el-form-item
        prop="card_type"
        label="类型"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.card_type"
                placeholder="请选择"
                width="50"
        >
          <el-option
                  v-for="item in typeOptions3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="price"
              label="原价格(元)"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.oldprice"></el-input>
      </el-form-item>

      <el-form-item
              prop="price"
              label="价格(元)"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.price"></el-input>
      </el-form-item>
      <el-form-item
              prop="notice"
              label="积分"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.notice"></el-input>
      </el-form-item>
      <el-form-item
              prop="unit"
              label="数量"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.unit"></el-input>
      </el-form-item>
      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as memberService from '@/api/sys/member'
import util from '@/libs/util.js'
export default {
  name: 'agentEditForm',
  props: {
    agent: Object,
    value: Boolean
  },
  data () {
    return {
      formEdit: true,
      formEdit2: true,
      loading: false,
      dialogVisible: false,
      pickerOptions: {}, // 日期设置对象
      form: {
        card_type: '',
        price: '',
        oldprice: '',
        title: '',
        title_details: '',
        unit: '',
        notice: ''

      },
      typeOptions3: [{
        value: '日',
        label: '日'
      },
      {
        value: '周',
        label: '周'
      },
      {
        value: '月',
        label: '月'
      },
      {
        value: '季',
        label: '季'
      },
      {
        value: '半年',
        label: '半年'
      },
      {
        value: '年',
        label: '年'
      }]
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {

    dialogOpen () {
      this.$refs.form.resetFields()

      if (this.agent.id) {
        // userService.getUser(this.user.id).then(data => {
        let form = {}
        form.card_type = this.agent.card_type
        form.price = this.agent.price
        form.oldprice = this.agent.oldprice
        form.title = this.agent.title
        form.title_details = this.agent.title_details
        form.notice = this.agent.notice
        form.unit = this.agent.unit
        this.form = form
        // });
        this.formEdit = true
        this.formEdit2 = false
      } else {
        this.formEdit = true
        this.formEdit2 = true
        this.form = {}
      }
    },

    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          memberService.saveMemberCard({ ...this.form, agentid: util.cookies.get('agentid'), id: this.agent.id, xt_id: util.cookies.get('xt_id') })
            .then(data => {
              this.loading = false
              this.dialogVisible = false
              this.$emit('submit')
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
